import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

const CrecheTeam = (props) => {
  const { dataTeam } = props;
  let team = dataTeam.team;
  if (!_.isEmpty(team)) {
    return (
      <div className="bloc-team-day mt-4 box-shadow">
        <div className="title-team bg-blue">Équipe du jour</div>
        <div className="d-flex align-items-stretch justify-content-between">
          <div className="tranche-horaire d-flex align-items-center">
            <div>
              <span>Matin</span>
              <p>{team.presentsMatin}</p>
            </div>
          </div>
          <div className="tranche-horaire d-flex align-items-center">
            <div>
              <span>Midi</span>
              <p>{team.presentsMidi}</p>
            </div>
          </div>
          <div className="tranche-horaire d-flex align-items-center">
            <div>
              <span>Après-midi</span>
              <p>{team.presentsApresMidi}</p>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return "";
  }
};

CrecheTeam.propTypes = {
  dataTeam: PropTypes.object,
};

export default CrecheTeam;
